export const USER_LOGGED_IN = "USER_LOGGED_IN"; 
export const USER_ACCESS_TOKEN = "USER_ACCESS_TOKEN";
export const USER_SET_FIRST_NAME = "USER_SET_FIRST_NAME";

// action creators
export function setuserLoggedIn(isLoggedIn) {
    return {
        type: USER_LOGGED_IN,
        val: isLoggedIn
    }
}

export function setFirstName(firstName) {
    return {
        type: USER_SET_FIRST_NAME,
        val: firstName
    }
}

export function setAccessToken(accessToken) {
    return {
        type: USER_ACCESS_TOKEN,
        val: accessToken
    }
}
